export enum AdminTableMenusOptions {
  SETTINGS = 'settings',
  YEAR = 'year',
  TRAVEL_COST = 'travelCost',
  EMPLOYER = 'employer',
  POOLS = 'pools',
  CLA = 'cla',
  MRP = 'mrp'
}
